import React, { useEffect, useState } from "react";
import axios from "axios";
import { shallow } from "zustand/shallow";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import {
  LoyaltyMembership,
  HogMembership,
} from "@components/LoyaltyMembership";
import { rideChallengeUserLookup } from "@components/RideChallengeApp/userLookup";
import hogLogo from "@assets/images/hog-logo-color.png";
import expiredMembershipLogo from "@assets/images/hog-membership-expired-logo.png";

import useAppStore from "@components/Microsite/microsite-store";

export default function DashboardMembership({ children, onMembershipCreated }) {
  const { t } = useTranslation();
  const [membershipLoading, setMembershipLoading] = useState(true);

  const {
    coords,
    location,
    setAppLoading,
    user,
    entityInfo,
    searchParamsOnInit,
  } = useAppStore(
    (state) => ({
      coords: state.coords,
      location: state.location,
      user: state.user,
      setAppLoading: state.setAppLoading,
      entityInfo: state.entityInfo,
      searchParamsOnInit: state.searchParamsOnInit,
    }),
    shallow
  );
  const [membership, setMembership] = useState(null);
  const isVehicleDataEffort = entityInfo.is_vehicle_data_effort;

  useEffect(() => {
    if (
      (!user.hog_membership_data ||
        (user.hog_membership_data.confirmed_by_third_party_api === false &&
          user.hog_membership_data.phone_match === false)) &&
      !isVehicleDataEffort
    ) {
      setMembershipLoading(false);
      return;
    } else {
      fetchMembership();
    }
  }, []);

  function fetchMembership() {
    const req = {
      ...coords,
      campaign_effort_id: entityInfo.campaign_effort_id,
      location_id: location?.id,
      user_id: user.id,
    };

    setAppLoading(true);
    setMembershipLoading(true);

    axios
      .post(`/ride-challenge/retrieve-hog-membership/`, req)
      .then(({ data }) => {
        setMembership(data.response[0]);
        setAppLoading(false);
        setMembershipLoading(false);
      })
      .catch((err) => {
        setMembership(null);
        setAppLoading(false);
        setMembershipLoading(false);
      });
  }

  if (
    !membership &&
    // (!membership || !membership.confirmed_by_third_party_api) &&
    !membershipLoading
  ) {
    return (
      <div>
        <StyledLogo
          src={hogLogo}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
        />
        <HogMembership
          additionalReqData={{
            ...coords,
            location_id: entityInfo.organization_id ? null : location?.id,
            organization_id: entityInfo.organization_id,
            user_id: user?.id,
            campaign_effort_id: entityInfo.campaign_effort_id,
          }}
          searchParamsHogIdValue={searchParamsOnInit?.hog_id}
          setMembershipInfo={(e) => {
            rideChallengeUserLookup({
              userInfo: {
                email: user?.email,
                mobile_phone: user?.mobile_phone,
              },
            }).then((user) => {
              // setMembership(user);
              // fetchMembership();
              // setAppLoading(false);
              onMembershipCreated();
            });
          }}
          userInfo={user}
        />
        {isVehicleDataEffort && <Box mt="lg">{children}</Box>}
      </div>
    );
  }

  const membershipExpired = membership?.ident?.startsWith("XX") ?? false;

  return (
    <div>
      {membership && (
        <div>
          <StyledLogo
            src={membershipExpired ? expiredMembershipLogo : hogLogo}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            style={{ maxWidth: membershipExpired ? "150px" : "300px" }}
          />
          {membershipExpired && (
            <Text
              align="center"
              maw="75%"
              mx="auto"
              fw={600}
              c="yellow"
              my="lg"
              size="md"
            >
              {t("microsite:dashboard_membership_expired_text")}
              <br />
              {t("microsite:dashboard_membership_expired_subtitle")}
            </Text>
          )}
          <LoyaltyMembership
            codeVerificationData={{
              ...coords,
              user_location_id: user?.user_location_id,
              campaign_effort_id: entityInfo.campaign_effort_id,
              location_id: location?.id,
              user_id: user?.id,
            }}
            membership={{
              ...membership,
              hog_membership_expired: membershipExpired,
            }}
            additionalReqData={{
              check: true,
              user_id: user.id,
              user_location_id: user.user_location_id,
              variety: 1,
              campaign_effort_id: entityInfo.campaign_effort_id,
            }}
            fetchData={fetchMembership}
          >
            {children}
          </LoyaltyMembership>
        </div>
      )}
    </div>
  );
}

const StyledLogo = styled(motion.img)`
  max-width: 300px;
  margin: 1.5em auto 1em auto;
  display: block;
`;
